import { useProfile } from 'hooks';
import { checkEveryPermissions, checkPermissions } from 'utils/check-permission';

/**
 * Hàm hook kiểm tra quyền, chỉ trả về boolean.
 */
export const CheckPermissionsButton = (permission: number | number[]): boolean => {
  const { userPermissionIds } = useProfile();

  if (!Array.isArray(userPermissionIds)) return false;

  return typeof permission === 'number'
    ? checkPermissions(userPermissionIds, permission)
    : checkEveryPermissions(userPermissionIds, permission);
};
